import { mapPrefixes, } from '@/utils/challenge/relationship'
import { timeFormat, } from '@/store/helpers'

let periodsTypes = [ 'ACCOUNTING_PERIOD', 'RELATIONSHIP_PERIOD', 'DOCUMENT_FILING_PERIOD', ]
const periods = (prefix, index) => ([
  {
    label: 'Relationship Period Type',
    type: 'ENUM',
    fieldId: 'RR_RELATIONSHIP_PERIOD_TYPE',
    jsonPath: `$.${prefix}.periods[${index}].type`,
  },
  {
    label: 'Relationship Period Start Date',
    type: 'DATE',
    fieldId: 'RR_RELATIONSHIP_PERIOD_START_DATE',
    jsonPath: `$.${prefix}.periods[${index}].startDate`,
    text: 'Current start date of the period.',
    proposeText: 'Select a proposed start date for this period.',
  },
  {
    label: 'Relationship Period End Date',
    type: 'DATE',
    fieldId: 'RR_RELATIONSHIP_PERIOD_END_DATE',
    jsonPath: `$.${prefix}.periods[${index}].endDate`,
    text: 'Current end date of the period.',
    proposeText: 'Select a proposed end date for this period.',
  },
])
const periodRow = (item, prefix, index) => (
  {
    periodType: {
      value: item,
      type: 'ENUM',
      jsonPath: `$.${prefix}.periods[${index}].type`,
    },
    startDate: {
      value: null,
      type: 'DATE',
      jsonPath: `$.${prefix}.periods[${index}].startDate`,
    },
    endDate: {
      value: null,
      type: 'DATE',
      jsonPath: `$.${prefix}.periods[${index}].endDate`,
    },
    prefix,
    type: 'DATE_RANGE',
    label: 'Period',
  }
)

const createField = (prefix, value, prop, type, idx) => ({
  value,
  type,
  jsonPath: `$.${prefix}.periods[${idx}].${prop}`,
})

const checkIsValidValue = (value) => {
  return typeof value === 'string' || typeof value === 'undefined'
}

const createPeriods = (prefix) => {
  const result = []
  const quantity = 150

  for (let i = 0; i < quantity; i++) {
    result.push(...periods(prefix, i))
  }
  return result
}

export const parsePeriodsData = (periods, prefix) => {
  if (Array.isArray(periods) && periods.length) {
    return periods.map((item, idx) => {
      if (checkIsValidValue(item.type)) {
        item.periodType = createField(prefix, item.type, 'type', 'ENUM', idx)
      }
      if (checkIsValidValue(item.startDate)) {
        item.startDate = createField(prefix, timeFormat(item.startDate), 'startDate', 'DATE', idx)
      }
      if (checkIsValidValue(item.endDate)) {
        item.endDate = createField(prefix, timeFormat(item.endDate), 'endDate', 'DATE', idx)
      }
      item.prefix = prefix
      item.label = 'Period'
      item.type = 'DATE_RANGE'
      return item
    })
  }
  return defaultPeriods(prefix)
}

export const defaultPeriods = (prefix, types = periodsTypes) => {
  const result = []

  types.forEach((item, idx) => {
    const index = idx + 50
    result.push(periodRow(item, prefix, index))
  })
  return result
}

export default mapPrefixes(createPeriods)



// WEBPACK FOOTER //
// ./src/utils/challenge/relationship-periods.js